import { useClientSettingsStore } from "@/store/clientSettings";
import { useStickyTypeStore } from "@/store/stickyType";

import { BaseBoard } from "./BaseBoard";

export class FlexBoard extends BaseBoard<"flex"> {
  override get showPermanentLinks() {
    return useClientSettingsStore().permanentTeamRiskCanvasLinks;
  }

  get possibleStickyTypes() {
    return useStickyTypeStore().flexBoardStickyTypes(this.board.flexType.id);
  }

  get contextActions() {
    return {
      board: { draw: this.drawAction() },
      selection: { organize: true },
    };
  }
}
